import GetAppsContainer from '~/src/components/GetAppsContainer'
import AppsBrowser from '~/src/components/svg/AppsBrowser'

interface Props {
  appStoreCampaign?: string
}

const ExtensionInstallBanner: React.FC<Props> = ({ appStoreCampaign }) => {
  return (
    <div className='bg-bellblue relative mx-auto space-y-10 border-t-2 border-t-black px-6 py-8 text-black md:px-14 md:py-12 md:pb-[200px]'>
      <GetAppsContainer appStoreCampaign={appStoreCampaign} inline />

      <div className='absolute bottom-0 right-0 hidden md:block'>
        <AppsBrowser />
      </div>
    </div>
  )
}

export default ExtensionInstallBanner
